<template>
	<material-popup :dialogShowModel="showImportAdminIncomeDeclarations" @escintent="showImportAdminIncomeDeclarations = false">
		<material-card :fullscreenadapter="$vuetify.breakpoint.xsOnly" icon="fas fa-file-import" :title="$t('incomedeclarations.import_label')" dismissable @dismissed="showImportAdminIncomeDeclarations = false">
			<div slot="after-heading">
				{{ $t("incomedeclarations.import_helper") }}
			</div>
			<upload-file @fileuploaded="importAdminIncomeDeclarationsRead" :uploading="adminincomedeclarations_importing" v-if="!readedAdminIncomeDeclarationsImport"></upload-file>
			<material-table v-else dense disable-sort hide-default-footer disable-pagination :headers="adminimportincomedeclarations_headers" :items="readedAdminIncomeDeclarationsImport.columns" :loading="adminincomedeclarations_importing">
				<template v-slot:item.attribute="{ item }">
					<v-select class="my-0 py-0" hide-details v-bind:items="availableAttributes(item)" clearable v-model="item.attribute"></v-select>
				</template>
				<template v-slot:item.first_row="{ item }">
					{{ firstRow(item.order) }}
				</template>
			</material-table>
			<template slot="actions" v-if="readedAdminIncomeDeclarationsImport">
				<v-col cols="6" xs="6" sm="3">
					<action-button large @click="showImportAdminIncomeDeclarations = false" outlined :text="$t('global.undo')"></action-button>
				</v-col>
				<v-col cols="6" xs="6" sm="3">
					<action-button large @click="importAdminIncomeDeclarations()" color="success" :disabled="adminincomedeclarations_importing" :loading="adminincomedeclarations_importing" :text="$t('global.save')"></action-button>
				</v-col>
			</template>
		</material-card>
	</material-popup>
</template>

<script>
export default {
	data: () => ({
		formData: null,
	}),
	computed: {
		adminincomedeclarations_importing() {
			return this.$store.getters.adminincomedeclarations_importing;
		},
		readedAdminIncomeDeclarationsImport: {
			get: function () {
				return this.$store.getters.getReadedAdminIncomeDeclarationsImport;
			},
			set: function (value) {
				this.$store.commit("setReadedAdminIncomeDeclarationsImport", value);
			},
		},
		showImportAdminIncomeDeclarations: {
			get: function () {
				return this.$store.getters.showImportAdminIncomeDeclarations;
			},
			set: function (value) {
				if (value == false) {
					this.$store.dispatch("hideAction", "hideImportAdminIncomeDeclarations");
				}
			},
		},
		adminimportincomedeclarations_headers() {
			let headers = [];
			headers.push({
				text: this.$t("global.import_column"),
				value: "column",
				align: "left",
				sortable: false,
			});
			headers.push({
				text: this.$t("global.import_attribute"),
				value: "attribute",
				align: "left",
				sortable: false,
			});
			headers.push({
				text: this.$t("global.import_first_row"),
				value: "first_row",
				align: "left",
				sortable: false,
			});
			return headers;
		},
	},
	methods: {
		firstRow(order) {
			if (this.readedAdminIncomeDeclarationsImport.first_row) {
				if (this.readedAdminIncomeDeclarationsImport.first_row[order]) {
					return this.readedAdminIncomeDeclarationsImport.first_row[order];
				}
			}
			return null;
		},
		availableAttributes(item) {
			let attributes = _.cloneDeep(this.readedAdminIncomeDeclarationsImport.attributes);
			let used = this.readedAdminIncomeDeclarationsImport.columns.map((obj) => obj.attribute);
			return _.filter(attributes, function (o) {
				return _.indexOf(used, o) == -1 || o == item.attribute;
			});
		},
		importAdminIncomeDeclarationsRead(files) {
			this.formData = new FormData();
			this.formData.append("fileincomedeclarations", files[0]);
			this.$store.dispatch("importAdminIncomeDeclarationsRead", this.formData);
		},
		importAdminIncomeDeclarations() {
			let columns = {};
			this.readedAdminIncomeDeclarationsImport.attributes.forEach((attribute) => {
				let $finded = this.readedAdminIncomeDeclarationsImport.columns.findIndex((obj) => obj.attribute == attribute);
				if ($finded != -1) {
					columns[attribute] = this.readedAdminIncomeDeclarationsImport.columns[$finded].order;
				} else {
					columns[attribute] = null;
				}
			});
			this.formData.append("columns", JSON.stringify(columns));
			this.$store.dispatch("importAdminIncomeDeclarationsStore", this.formData);
		},
	},
};
</script>
